import { filestackPicker } from "../framework/uploader";

const Form = {
  FILE_UPLOADER_SELECTOR: ".js-file-upload",
  RESET_BG_IMAGE_SELECTOR: ".custom-diploma-form-remove-bg-image-btn",
  FORM_CONTAINER_SELECTOR: ".custom-diploma-form-container",

  run() {
    this.handleFileUpload();
    this.initTextareas();
    this.handleTextareaResize();
    this.handleResettingBackgroundImage();
  },

  handleFileUpload() {
    document.querySelectorAll(this.FILE_UPLOADER_SELECTOR).forEach((button) => {
      button.addEventListener("click", this.handleFileUploadButtonClick.bind(this));
    });
  },

  async handleFileUploadButtonClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const { uploadPath, target, placeholderTarget, property, resourceName } = this.fetchData(event);

    const {
      filesUploaded: [uploadedFile],
      filesFailed,
    } = await filestackPicker({
      path: uploadPath,
      accept: [".png", ".jpeg", ".jpg"],
      maxWidth: 2000,
      maxHeight: 2000,
      transformations: { crop: true, rotate: true, circle: true },
    });

    if (filesFailed.length > 0) {
      filesFailed.forEach((file) => console.error("Failed uploading file", file));
    }

    if (uploadedFile) {
      const $target = $(target);
      if (property == "background-image") {
        $target.css("background-image", `url(${uploadedFile.url})`);
        $(this.RESET_BG_IMAGE_SELECTOR).removeClass("custom-diploma-form-remove-bg-image-btn--hidden");
        window.dispatchEvent(new CustomEvent("background_image_changed", { detail: { url: uploadedFile.url } }));
      } else {
        $target.attr(property, uploadedFile.url).prop("hidden", false);
        window.dispatchEvent(new CustomEvent("uploaded_image_added", { detail: { url: uploadedFile.url } }));
        $(placeholderTarget).attr("hidden", "hidden");
      }

      $(`input[name="custom_diploma_template[${resourceName}][path]"]`).val(uploadPath);
      $(`input[name="custom_diploma_template[${resourceName}][url]"]`).val(uploadedFile.url);
      $(`input[name="custom_diploma_template[${resourceName}][filename]"]`).val(uploadedFile.filename);
      $(`input[name="custom_diploma_template[${resourceName}][size]"]`).val(uploadedFile.size);
      $(`input[name="custom_diploma_template[${resourceName}][mime]"]`).val(uploadedFile.mime);
      $(`input[name="custom_diploma_template[${resourceName}][_delete]"]`).val(false);
    }
  },

  fetchData({ target }) {
    if (target.classList.contains(this.FILE_UPLOADER_SELECTOR.substring(1))) {
      return target.dataset;
    } else {
      return $(target).parents(this.FILE_UPLOADER_SELECTOR)[0].dataset;
    }
  },

  initTextareas() {
    const _this = this;
    $(".js-textarea").each(function () {
      _this.autoResizeTextarea(this);
    });
  },

  handleTextareaResize() {
    $(".js-textarea").on("keyup resize", ({ target }) => {
      this.autoResizeTextarea(target);
    });
  },

  handleResettingBackgroundImage() {
    $(this.RESET_BG_IMAGE_SELECTOR).on("click", (event) => {
      event.stopPropagation();
      event.preventDefault();

      $(this.FORM_CONTAINER_SELECTOR).css("background-image", "");
      $(this.RESET_BG_IMAGE_SELECTOR).addClass("custom-diploma-form-remove-bg-image-btn--hidden");
      $("input[name^='custom_diploma_template[background_image]']").val(null);
      $("input[name^='custom_diploma_template[background_image][_delete]']").val(true);
      const defaultBgUrl = "/images/diploma/default.png";

      window.dispatchEvent(new CustomEvent("background_image_changed", { detail: { url: defaultBgUrl } }));
    });
  },

  autoResizeTextarea(textarea) {
    textarea.style.height = "1px";
    textarea.style.height = `${textarea.scrollHeight}px`;
  },
};

document.addEventListener("DOMContentLoaded", () => {
  Form.run();
});
